import { createContext, useContext, useState, useCallback, type ReactNode } from "react";

interface BranchContextType {
  activeBranchId: string | null; // null = All Branches
  setActiveBranchId: (id: string | null) => void;
}

const BranchContext = createContext<BranchContextType | undefined>(undefined);

export function BranchProvider({ children }: { children: ReactNode }) {
  const [activeBranchId, setActiveBranchIdState] = useState<string | null>(() => {
    return localStorage.getItem("active_branch_id") || null;
  });

  const setActiveBranchId = useCallback((id: string | null) => {
    if (id) localStorage.setItem("active_branch_id", id);
    else localStorage.removeItem("active_branch_id");
    setActiveBranchIdState(id);
  }, []);

  return (
    <BranchContext.Provider value={{ activeBranchId, setActiveBranchId }}>
      {children}
    </BranchContext.Provider>
  );
}

export function useBranchContext() {
  const ctx = useContext(BranchContext);
  if (!ctx) throw new Error("useBranchContext must be used within BranchProvider");
  return ctx;
}
